import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, useCallback, useMemo, useState } from "react";
import classNames from "classnames";
import { SwiperSlide } from "swiper/react";
import { LongArrowBackwardIcon } from "@jti/brand-icons/long-arrow-backward";
import { LongArrowForwardIcon } from "@jti/brand-icons/long-arrow-forward";
import { useDirection } from "@jti/fe-common";
import { SwiperJti } from "../SwiperJti";
import styles from "./Carousel.module.scss";
const BREAKPOINT_SMALL_LARGE = 768; // css variable $breakpoint-small-large
const BREAKPOINT_LARGE = 1024; // css variable $breakpoint-large
export const Carousel = ({ desktopItemCount = 3, tabletItemCount = 2, children, isOverflowEnabled, isControlHidden, isViewportHeight = false, }) => {
    const childrenArray = useMemo(() => Children.toArray(children), [children]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [swiperInstance, setSwiperInstance] = useState(null);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);
    const direction = useDirection();
    const isRtl = direction === "rtl";
    const handleNextClick = useCallback(() => {
        if (!isEnd) {
            swiperInstance?.slideTo(activeIndex + 1);
        }
    }, [swiperInstance, activeIndex, isEnd]);
    const handlePrevClick = useCallback(() => {
        if (!isBeginning) {
            swiperInstance?.slideTo(activeIndex - 1);
        }
    }, [swiperInstance, activeIndex, isBeginning]);
    return (_jsxs("div", { className: styles.carousel, children: [_jsx(SwiperJti, { rtl: isRtl, isOverflowEnabled: isOverflowEnabled, isShowNavigationArrows: false, isShowPaginationButtons: false, isContainerWidth: true, isViewportHeight: isViewportHeight, touchStartPreventDefault: true, slidesPerView: 1, spaceBetween: 24, onSwiper: (swiper) => {
                    setSwiperInstance(swiper);
                }, onSlideChange: (swiper) => {
                    setActiveIndex(swiper.realIndex);
                    setIsBeginning(swiper.isBeginning);
                    setIsEnd(swiper.isEnd);
                }, className: styles.content, breakpoints: {
                    [BREAKPOINT_SMALL_LARGE]: {
                        slidesPerView: tabletItemCount,
                    },
                    [BREAKPOINT_LARGE]: {
                        slidesPerView: desktopItemCount,
                    },
                }, children: childrenArray.map((child, index) => (_jsx(SwiperSlide, { className: styles.item, children: child }, index))) }, `${tabletItemCount}-${desktopItemCount}`), !isControlHidden && (_jsxs("div", { className: styles.controls, children: [_jsx("button", { className: styles.arrowButton, "data-testid": "prev-button", onClick: handlePrevClick, disabled: isBeginning, children: _jsx(LongArrowBackwardIcon, { className: styles.arrowIcon }) }), _jsx("button", { className: classNames(styles.arrowButton), "data-testid": "next-button", onClick: handleNextClick, disabled: isEnd, children: _jsx(LongArrowForwardIcon, { className: styles.arrowIcon }) })] }))] }));
};
//# sourceMappingURL=Carousel.js.map